// Linear's three health values, with the label Linear shows for each.
export const PROJECT_HEALTH: Record<
	string,
	{ label: string; className: string }
> = {
	onTrack: {
		label: "On track",
		className: "text-green-600 dark:text-green-500",
	},
	atRisk: {
		label: "At risk",
		className: "text-yellow-600 dark:text-yellow-500",
	},
	offTrack: { label: "Off track", className: "text-red-600 dark:text-red-500" },
}

export const progressPercent = (progress: number | null | undefined) =>
	progress === null || progress === undefined
		? null
		: Math.round(Math.min(Math.max(progress, 0), 1) * 100)
